/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React, { useState, useEffect, useCallback } from 'react'
import AppliedOfferToolTip from '../../Components/AppliedOfferToolTip/Index'

export default function EubSummarySection({ type, Calculation, orderFlow, GetCalculation, adorCashCheck, setadorCashCheck, OrderData, Privilages }) {
    const [appliedOfferHover, setappliedOfferHover] = useState('');
    const [adorcashType, setadorcashType] = useState('')
    const handleAmount = (value) => {
        return Number(value)?.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
        })
    }
    // const [adorCashCheck, setadorCashCheck] = useState(false);
    const getCalculation = useCallback(
        () => {
            GetCalculation();
            setadorcashType()
        },
        [orderFlow],
    )

    useEffect(() => {
        getCalculation();
        setadorcashType(handlePrivilage())
    }, [getCalculation])

    const handlePrivilage = () => {
        let res = '';
        let type = ''
        Privilages.map((val) => {
            if (val === 'ador_cash_debit' || val === 'cash_discount') {
                res = true
                type = val

            }
        })
        return type
    }
    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.15 }} >
            <div

                className="py-1 border-b border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Order value</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">{
                        handleAmount(Calculation?.order_value)}</p>
                </div>
                <div className="flex justify-between items-center border-b bordder-[#CBCBCB] sm:pb-1 py-2">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal flex items-center">
                        Discount
                        <span className="ml-1 relative">
                            <button
                                onMouseEnter={() => {
                                    setTimeout(() => {
                                        setappliedOfferHover('active')
                                    }, 1000);
                                }} onMouseLeave={() => {
                                    setTimeout(() => {
                                        setappliedOfferHover('')
                                    }, 2000);
                                }}
                                data-tooltip-target="tooltip-discountPercentage1" data-tooltip-placement="right" data-tooltip-trigger="click" type="button">
                                <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                            </button>
                            {appliedOfferHover !== '' && (
                                <AppliedOfferToolTip hover={appliedOfferHover !== ''} prod={Calculation} />
                            )}
                        </span>
                    </p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">- {Number(Calculation?.total_discount).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) || 0.00}</p>
                </div>
                <>{type &&
                    <div className="flex justify-between items-center sm:mt-0 mt-1">
                        <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Add. Discount</p>
                        <p className="sm:text-lg text-base font-semibold text-[#555259]">{
                            handleAmount(Calculation?.proposed_additional_discount)
                        }</p>
                    </div>}</>
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">DAP</p>
                    <p className="text-[#555259]"
                        style={{ maxWidth: '100px', flexWrap: 'wrap', fontSize: '10px', color: '#555259' }}>
                        <p className="sm:text-lg text-end font-semibold text-[#555259]">{handleAmount(Calculation.dap_charges)}</p>
                        DAP will be confirmed once order is approved
                    </p>
                </div>
            </div>
            <div className="sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center mt-1.5">
                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Sub Total</p>
                    <p className="sm:text-xs7 text-base font-semibold text-[#000000]">{
                        type ? handleAmount(Calculation?.proposed_net_amount) : handleAmount(Calculation?.order_net_amount)}</p>
                </div>
                {Privilages.length > 0 && adorcashType !== '' && OrderData === undefined || OrderData?.status === "0" ?
                    <>
                        {adorcashType === 'ador_cash_debit' && <>{Number(Calculation?.proposed_avail_ador_cash) > 0
                            || Number(Calculation?.order_avail_ador_cash) > 0 ?
                            (<div className="relative checkbox custom-checkbox-offer flex items-center mt-1 mb-2.5">
                                <input type="checkbox" id="checkbox-1"
                                    checked={adorCashCheck}
                                    onChange={() => setadorCashCheck(!adorCashCheck)}
                                    className="cursor-pointer" />
                                <label htmlFor="checkbox-1" className="pl-2 text-sm font-normal text-[#000000] cursor-pointer">
                                    Use Ador Cash ({handleAmount(Number(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash))})</label>
                            </div>)
                            : null}
                        </>}
                        {adorcashType === 'cash_discount' && <>{Number(Calculation?.cash_discount) > 0 ?
                            <>
                                <div className="relative checkbox custom-checkbox-offer flex items-center justify-between mt-1 mb-2.5">
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="checkbox-1"
                                            checked={adorCashCheck}
                                            onChange={() => setadorCashCheck(!adorCashCheck)}
                                            className={`text-black ${Calculation?.overdue_status === true && Calculation.overdue_amount>0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                                            disabled={Calculation?.overdue_status === true && Calculation.overdue_amount>0} />
                                        <label htmlFor="checkbox-1" className={`pl-1 text-sm font-normal text-[#000000] ${Calculation?.overdue_status === true && Calculation.overdue_amount>0 ? 'cursor-not-allowed opacity-[0.3]' : 'cursor-pointer'}`}>Use Cash Disc({Calculation.cash_discount}%)</label>
                                    </div>
                                    <p className={`sm:text-xs7 text-base font-semibold ${Calculation?.overdue_status === true && Calculation.overdue_amount>0 ? 'text-[#000000] opacity-[0.3]' : 'text-[#000000]'}`}>{handleAmount(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash)}</p>
                                </div>
                                {Calculation?.overdue_status === true && Calculation.overdue_amount>0 &&
                                <p className='text-[#555259] text-xs font-normal'>{handleAmount(Calculation.overdue_amount)} amount is overdue</p>
                                }
                            </>
                            :
                            null
                        }
                        </>}

                    </>
                    :


                    <>{Number(OrderData?.ador_cash_used) > 0 &&
                        <div className="flex justify-between items-center sm:mt-0 mt-1">
                            <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Ador cash used</p>
                            <p className="sm:text-lg text-base font-semibold text-[#555259]">{handleAmount(Number(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash) || 0)}</p>
                        </div>}</>


                }

            </div>
            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">Net Amount</p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">{type ?
                        <>{adorCashCheck ? handleAmount(Number(Calculation?.proposed_net_amount) - Number(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash)) : handleAmount(Calculation?.proposed_net_amount)}</>
                        :
                        <>{adorCashCheck ?
                            handleAmount(Number(Calculation?.order_net_amount) - Number(type ? Calculation?.proposed_avail_ador_cash : Calculation?.order_avail_ador_cash)) :
                            handleAmount(Calculation?.order_net_amount)}</>}</p>
                </div>
            </div>
            <div className="py-1 border-b border-t border-[#CBCBCB] sm:pr-1 sm:pl-2">
                <div className="flex justify-between items-center sm:mt-0 mt-1">
                    <p className="sm:text-xs18 text-sm text-[#555259] font-normal">GST <span>{`(18%)`}</span></p>
                    <p className="sm:text-lg text-base font-semibold text-[#555259]">{type ?
                        <>{adorCashCheck ? handleAmount(Calculation?.proposed_gst.ador_cash_avail_gst) : handleAmount(Calculation?.proposed_gst.gst)}</>
                        :
                        <>{adorCashCheck ?
                            handleAmount(Calculation?.order_gst.ador_cash_avail_gst) :
                            handleAmount(Calculation?.order_gst.gst)}</>}</p>
                </div>
            </div>
            <div className="sm:pr-1 sm:pl-2 border-b border-[#CBCBCB] py-1">
                <div className="flex justify-between items-center mt-1.5">
                    <p className="sm:text-xs18 text-sm text-[#000000] font-normal">Gross Amount</p>
                    <p className="md:text-xs4 text-base font-semibold text-[#000000]">{type ?
                        <>{adorCashCheck ? handleAmount(Calculation?.ador_cash_proposed_gross_amount) : handleAmount(Calculation?.proposed_gross_amount)}</>
                        :
                        <>{adorCashCheck ?
                            handleAmount(Calculation?.ador_cash_order_gross_amount) :
                            handleAmount(Calculation?.order_gross_amount)}</>}
                    </p>
                </div>
            </div>
        </motion.div >
    )
}
